import React, { useEffect, useState } from 'react';
import { Entity } from '../../types';
import { useEditContextSettings } from '../edit.provider';
import { ContextSettingSelectorProps } from '../types';
import { ContextSelectorMenu } from './menu';
import { SelectionList } from './selection.list';

function SingleSelect({ definition, values, onChange, onClose }: ContextSettingSelectorProps) {
  const [myOptions, setMyOptions] = useState<(string | Entity)[]>();
  const {
    name,
    selection: { options, optionsUrl },
  } = definition;
  const { getContextSettings } = useEditContextSettings();

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    const fetch = async () => {
      const settings = await getContextSettings([name]);
      const {
        definition: {
          selection: { options },
        },
      } = settings[name];
      if (options) {
        setMyOptions(options as Entity[]);
      }
    };

    if (!options && optionsUrl) {
      fetch();
    } else {
      setMyOptions(options as Entity[]);
    }
  }, [options, optionsUrl]);

  const handleItemSelect = (value: Entity) => {
    onChange({
      [name]: [value],
    });
    onClose();
  };

  return (
    <ContextSelectorMenu>
      <SelectionList options={myOptions} value={values} onItemClick={handleItemSelect} />
    </ContextSelectorMenu>
  );
}

export { SingleSelect };
